"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryBankType = void 0;
var CountryBankType;
(function (CountryBankType) {
    CountryBankType[CountryBankType["IBAN"] = 0] = "IBAN";
    CountryBankType[CountryBankType["BIC"] = 1] = "BIC";
    CountryBankType[CountryBankType["US"] = 2] = "US";
})(CountryBankType || (exports.CountryBankType = CountryBankType = {}));
//# sourceMappingURL=CountryBankType.js.map